module.exports = __webpack_public_path__ + "assets/img/img245.1645a8ca.png";